import './style.css';

export const Card = ({transaction, deleteCard}) => {

    return (

        <li className={`card ${transaction.type === 'Entrada' ? 'entrada' : 'saida'}`}>

            <div className='description-type'>
                <h3 className='description'>{transaction.description}</h3>
                <p className='transaction_type'>{transaction.type}</p>
            </div>

            <div className='value-icon'>
                <p className='value'> R$ {transaction.value}</p>
                <i className='bx bxs-trash-alt' onClick={() => {deleteCard(transaction)}}></i>
            </div>

        </li>

    );

}

//type === 'Entrada' ? 'entrada' : 'saida'